// extracted by mini-css-extract-plugin
export default {"heading":"ProgramTermsPage_heading__0fZiv","content":"ProgramTermsPage_content__a6udB"};